export default __webpack_public_path__ + "static/media/Pyramide-besoins_perso_n7_spiritualite.1121e70f.svg";